module.exports = __webpack_public_path__ + "img/fxfw.679ea24.png";